var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoInputCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7288 1.66827C12.0979 1.25741 12.064 0.625148 11.6532 0.256079C11.2423 -0.112989 10.61 -0.0791101 10.241 0.331751L4.64514 6.56123L1.68586 3.77227C1.28394 3.39348 0.65105 3.41224 0.272263 3.81416C-0.106523 4.21607 -0.0877703 4.84896 0.314149 5.22775L4.01248 8.71322C4.02029 8.7207 4.02826 8.72809 4.03637 8.73537C4.34698 9.0144 4.78415 9.06311 5.13846 8.89273C5.24774 8.84017 5.34915 8.76678 5.43652 8.67286C5.44167 8.66733 5.44675 8.66176 5.45175 8.65615L11.7288 1.66827Z",
    fill: "url(#paint0_linear_577_207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_577_207",
    x1: 11.9849,
    y1: 8.99144,
    x2: 0,
    y2: 8.99144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA51E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B51E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInputCheck);
export default __webpack_public_path__ + "static/media/ico-input-check.ebbe3f702aef470525234536d705c254.svg";
export { ForwardRef as ReactComponent };